import React from 'react';
import { Box, TablePagination, Pagination } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IPagination } from '../../hook/usePagination';

interface ICustomPagination {
    pagination: IPagination;
    onRowsChange: (params: any) => void;
    onPageChange: (params: any) => void;
    rowsPerPageOptions: number[];
}

const CustomPagination: React.FC<ICustomPagination> = ({
    pagination,
    onPageChange,
    onRowsChange,
    rowsPerPageOptions,
}) => {
    const { themeStyle } = useThemeContext();
    const CustomPaginationActions = () => {
        return (
            <div style={{ flexShrink: 0 }}>
                {null}
                {null}
                {null}
                {null}
                {null}
                {null}
            </div>
        );
    };

    const handlePageChange = (_: unknown, page: number) => {
        onPageChange(page);
    };

    const handleRowsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onRowsChange(+event.target.value);
        onPageChange(1);
    };

    return (
        <Box
            style={{
                width: '100%',
            }}>
            <Box display="flex" alignItems="flex-end" justifyContent="flex-end" width="100%">
                <TablePagination
                    component="div"
                    count={pagination.totalCount}
                    page={pagination.page - 1}
                    onPageChange={handlePageChange}
                    rowsPerPage={pagination.rows}
                    onRowsPerPageChange={handleRowsChange}
                    rowsPerPageOptions={rowsPerPageOptions}
                    ActionsComponent={CustomPaginationActions}
                    sx={{
                        color: theme[themeStyle].tag_white,
                        '& .MuiSvgIcon-root': {
                            color: theme[themeStyle].tag_white,
                        },
                    }}
                />
            </Box>

            <Pagination
                count={Math.ceil(pagination.totalCount / pagination.rows)}
                variant="outlined"
                page={pagination.page}
                shape="rounded"
                onChange={(_: any, page: number) => {
                    handlePageChange(_, page);
                }}
                sx={{
                    '& .MuiButtonBase-root': {
                        borderColor: theme[themeStyle].tag_white,
                        color: theme[themeStyle].tag_white,
                    },
                    '& .MuiPaginationItem-root': {
                        color: theme[themeStyle].tag_white,
                    },
                    '& .Mui-selected': {
                        backgroundColor: theme[themeStyle].highlight,
                        color: theme[themeStyle].true_white, // Selected text color
                        borderColor: theme[themeStyle].highlight, // Optional: border color when selected
                    },
                }}
            />
        </Box>
    );
};

export { CustomPagination };
